import React, { useEffect, useState } from "react";
import HRNavbar from "../../HR/HRNavbar";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import {
  TextField,
  Button,
  TablePagination,
  IconButton,
  Snackbar,
  Alert,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import InputBase from "@mui/material/InputBase";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import CardContent from "@mui/material/CardContent";
import { styled } from "@mui/system";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import TableCell from "@mui/material/TableCell";
import Footer from "../../../Footer";
import SearchIcon from "@mui/icons-material/Search";
import DatePicker from "react-multi-date-picker";
import dayjs from "dayjs";
import { API_URL } from "../../Config/api";
const HospitalCard = styled(Card)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "10px",
  marginRight: "10px",
  backgroundColor: "white",
  boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
  height: "43px",
  borderRadius: "10px",
  transition: "0.5s ease-in-out",
  '&:hover': {
    backgroundColor: '#F7F7F7',
    cursor: 'pointer',
    borderLeft: '2px solid #D1C4E9',
  },
  fontWeight: "200",
});

const RefundReports = () => {
  const [selectedDates, setSelectedDates] = useState([]);
  const [formattedDates, setFormattedDates] = useState([]);
  const [filterType, setFilterType] = useState("searchby");
  const [tempSearchValue, setTempSearchValue] = useState("");
  const [showSearchBox, setShowSearchBox] = useState(false);
  const [refundData, setRefundData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [data, setData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("warning");
  // const port = process.env.REACT_APP_API_KEY;
  const accessToken = localStorage.getItem("token");
  const getPlaceholderText = () => {
    switch (filterType) {
      case "eve_code":
        return "Search by event code...";
      case "Patient Number":
        return "Search by patient number...";
      case "Patient Name":
        return "Search by patient name...";
      case "Caller Number":
        return "Search by caller number...";
      default:
        return "Search here...";
    }
  };

  const handleTempSearchChange = (event) => {
    setTempSearchValue(event.target.value);
  };

  const handleFilterTypeChange = (event) => {
    const value = event.target.value;
    setFilterType(value);
    setShowSearchBox(value !== "searchby");
  };

  const handleDateChange = (dates) => {
    setSelectedDates(dates);

    const unwrapped = Array.isArray(dates[0]) ? dates[0] : dates;

    if (unwrapped.length === 2) {
      const start = new Date(unwrapped[0]).toISOString().split("T")[0];
      const end = new Date(unwrapped[1]).toISOString().split("T")[0];
      setFormattedDates([start, end]); // This should be set here
    }
  };

  // const fetchData = async () => {
  //   try {
  //     const baseURL =
  //       "http://testhhc.hospitalguru.in:8060/web/cashfreerefund_report/";

  //     let dateParams = "";
  //     if (formattedDates && formattedDates.length === 2) {
  //       // Ensure dates are valid and properly formatted
  //       const validStart = new Date(formattedDates[0]);
  //       const validEnd = new Date(formattedDates[1]);

  //       if (!isNaN(validStart) && !isNaN(validEnd)) {
  //         const start = validStart.toISOString().split("T")[0];
  //         const end = validEnd.toISOString().split("T")[0];
  //         dateParams = `?dates=${start},${end}`;
  //       }
  //     }

  //     const searchParam =
  //       filterType !== "searchby" && tempSearchValue
  //         ? `${dateParams ? "&" : "?"}${filterType}=${encodeURIComponent(
  //             tempSearchValue
  //           )}`
  //         : "";

  //     const url = `${baseURL}${dateParams}${searchParam}`;

  //     console.log("✅ Final API URL:", url);

  //     const res = await fetch(url);
  //     const json = await res.json();

  //     console.log("✅ Fetched Data:", json);
  //     setRefundData(json);
  //   } catch (error) {
  //     console.error("❌ Fetch failed:", error);
  //   }
  // };

  const fetchData = async () => {
    if (!filterType || filterType === "searchby" || !tempSearchValue.trim()) {
      setSnackbarMessage(
        "Please select a search filter and enter a search value."
      );
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
      return;
    }

    const baseURL = `${API_URL}/web/cashfreerefund_report/`;
    let urlParams = [];

    if (formattedDates.length === 2) {
      const start = new Date(formattedDates[0]).toISOString().split("T")[0];
      const end = new Date(formattedDates[1]).toISOString().split("T")[0];
      urlParams.push(`dates=${start},${end}`);
    }

    urlParams.push(
      `${filterType}=${encodeURIComponent(tempSearchValue.trim())}`
    );
    const finalURL =
      baseURL + (urlParams.length ? `?${urlParams.join("&")}` : "");

    setLoading(true);
    try {
      const res = await fetch(finalURL);
      const data = await res.json();

      // ✅ Trust backend filtered data
      if (!data || data.length === 0) {
        setSnackbarMessage("No matching records found.");
        setSnackbarSeverity("info");
        setSnackbarOpen(true);
      }

      setRefundData(data);
    } catch (error) {
      setSnackbarMessage("Failed to fetch data.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <div>
      <HRNavbar />
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Box sx={{ flexGrow: 0, ml: 1, mr: 1, mt: 2, mb: "3em" }}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
        >
          <Typography
            sx={{
              fontSize: 16,
              fontWeight: 600,
              marginTop: "20px",
              marginLeft: "10px",
            }}
            color="text.secondary"
            gutterBottom
          >
            Refund Report
          </Typography>

          <Box
            sx={{
              marginLeft: "1rem",
              display: "flex",
              alignItems: "center",
              borderRadius: "10px",
              padding: "2px 4px",
            }}
          >
            <DatePicker
              multiple
              range
              value={selectedDates}
              onChange={handleDateChange}
              placeholder="YYYY/MM/DD"
              format="YYYY-MM-DD"
              render={(value, openCalendar) => (
                <TextField
                  onClick={openCalendar}
                  label="Select Date *"
                  placeholder="YYYY/MM/DD"
                  size="small"
                  fullWidth
                  sx={{
                    height: 39,
                    boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
                    borderRadius: "8px",
                    backgroundColor: "white",
                    mb: 1,
                    width: 220,
                    mt: 0.8,
                  }}
                  value={formattedDates.join("-")}
                />
              )}
            />
          </Box>

          <Box
            component="form"
            sx={{
              marginLeft: "2rem",
              p: "2px 4px",
              display: "flex",
              alignItems: "center",
              width: 300,
              height: "2.5rem",
              backgroundColor: "#ffffff",
              boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
              borderRadius: "10px",
              border: "1px solid #C9C9C9",
            }}
          >
            <TextField
              select
              size="small"
              fullWidth
              value={filterType}
              onChange={handleFilterTypeChange}
              sx={{
                textAlign: "left",
                "& input": {
                  fontSize: "14px",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "none",
                  },
                },
              }}
            >
              <MenuItem value="searchby" disabled>
                Search by
              </MenuItem>
              <MenuItem value="caller_number" style={{ fontSize: "15px" }}>
                Caller Number
              </MenuItem>
              <MenuItem value="eve_code" style={{ fontSize: "15px" }}>
                Event Code
              </MenuItem>
              <MenuItem value="patient_name" style={{ fontSize: "15px" }}>
                Patient Name
              </MenuItem>
              <MenuItem value="patient_number" style={{ fontSize: "15px" }}>
                Patient Number
              </MenuItem>
            </TextField>
          </Box>

          {showSearchBox && (
            <Box
              component="form"
              sx={{
                marginLeft: "2rem",
                p: "2px 4px",
                display: "flex",
                alignItems: "center",
                width: 300,
                height: "2.5rem",
                backgroundColor: "#ffffff",
                boxShadow: "4px 4px 10px 7px rgba(135, 135, 135, 0.05)",
                borderRadius: "10px",
                border: "1px solid #C9C9C9",
              }}
            >
              <InputBase
                sx={{ ml: 1, flex: 1 }}
                placeholder={getPlaceholderText()}
                value={tempSearchValue}
                onChange={handleTempSearchChange}
              />
              <IconButton
                type="button"
                sx={{ p: "10px" }}
                aria-label="search"
              >
                <SearchIcon style={{ color: "#7AB7EE" }} />
              </IconButton>
            </Box>
          )}

          <Button
            variant="contained"
            onClick={fetchData}
            sx={{ backgroundColor: "#347B89", "&:hover": { backgroundColor: "#347B89" }}}
          >
            Submit
          </Button>
        </Stack>

        <TableContainer sx={{ ml: 1, mr: 1, }}>
          <Table>
            <TableHead>
              <TableRow>
                <HospitalCard
                  style={{
                    background: "#D1C4E9",
                    color: "#000000ff",
                    borderRadius: "8px 10px 0 0",
                    height: "3rem",
                  }}
                >
                  <CardContent
                    style={{ flex: 0.7, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Sr. No</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 3, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2"> Event Code</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 2.8, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Caller Number</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 2.5, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Caller Name</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 3, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Created At </Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 3, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Patient Name</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 3, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Patient Number</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 3, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Refund Amount</Typography>
                  </CardContent>
                  <CardContent
                    style={{ flex: 3, borderRight: "1px solid #FFFFFF" }}
                  >
                    <Typography variant="subtitle2">Status</Typography>
                  </CardContent>
                </HospitalCard>
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell
                    colSpan={8}
                    align="center"
                    style={{ height: "45vh" }}
                  >
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : refundData.length === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={8}
                    align="center"
                    style={{ height: "45vh" }}
                  >
                    <Typography variant="subtitle1">No data found</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                refundData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const totalRefund =
                      row.cashwebbook?.reduce(
                        (acc, cur) => acc + (cur.refund_amount || 0),
                        0
                      ) || 0;
                    const status = row.cashwebbook?.[0]?.refund_status || "-";
                    return (
                      <TableRow key={index}>
                        <HospitalCard
                          style={{
                            background: "white",
                            color: "rgba(0, 0, 0, 0.87)",
                            height: "3rem",
                          }}
                        >
                          <CardContent style={{ flex: 0.7 }}>
                            <Typography variant="subtitle2">
                              {page * rowsPerPage + index + 1}
                            </Typography>
                          </CardContent>

                          <CardContent style={{ flex: 3 }}>
                            <Typography variant="subtitle2">
                              {row.eve_code || "-"}
                            </Typography>
                          </CardContent>
                          <CardContent style={{ flex: 2.8 }}>
                            <Typography variant="subtitle2">
                              {row.caller_number || "-"}
                            </Typography>
                          </CardContent>
                          <CardContent style={{ flex: 2.5 }}>
                            <Typography variant="subtitle2">
                              {row.caller_name || "-"}
                            </Typography>
                          </CardContent>
                          <CardContent style={{ flex: 3 }}>
                            <Typography variant="subtitle2">
                              {row.refund_created_date
                                ? dayjs(row.refund_created_date).format(
                                  "YYYY-MM-DD HH:mm"
                                )
                                : "-"}
                            </Typography>
                          </CardContent>
                          <CardContent style={{ flex: 3 }}>
                            <Typography variant="subtitle2">
                              {row.patient_name || "-"}
                            </Typography>
                          </CardContent>
                          <CardContent style={{ flex: 3 }}>
                            <Typography variant="subtitle2">
                              {row.patient_number || "-"}
                            </Typography>
                          </CardContent>
                          <CardContent style={{ flex: 3 }}>
                            <Typography variant="subtitle2">
                              {totalRefund}
                            </Typography>
                          </CardContent>
                          <CardContent style={{ flex: 3 }}>
                            <Typography variant="subtitle2">
                              {status}
                            </Typography>
                          </CardContent>
                        </HospitalCard>
                      </TableRow>
                    );
                  })
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          sx={{ overflowY: "hidden" }}

          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={refundData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
      <Footer />
    </div>
  );
};

export default RefundReports;
